import Cookies from 'js-cookie';
import { axios } from 'lib/axios';

export const login2FA = async (data) => {
  const response = await axios.post('/user/passwordLogin', data);
  let user;
  user = await handleLoginUserResponse(response);
  return user;
};

async function handleLoginUserResponse(data) {
  const { user } = data;
  Cookies.set('temp_token', user.token, { expires: 5 / 1440 });
  return user;
}
